import Button from '@components/button';
import NavigationItem from '@components/header/components/navigation/navigation-item.view';
import ThemeToggler from '@components/theme-toggler/theme-toggler.view';
import Link from 'next/link';
import type { ReactElement } from 'react';
import React from 'react';
import type { NavigationLink } from 'types/navigation-link';
import { validateString } from 'utils/validate-string';

import styles from './navigation-list.module.scss';

interface Props {
  readonly links: NavigationLink[];
  readonly themeSwitcher?: boolean | undefined;
}

const rootClass = validateString(styles.root);

function NavigationList({ links, themeSwitcher = false }: Props): ReactElement {
  return (
    <ul className={rootClass}>
      {/* Desktop Menu */}
      {links
        .filter(link =>
          typeof link.highlight !== 'undefined'
            ? link.highlight === false
            : true,
        )
        .map(link => (
          <NavigationItem key={link.label} link={link} />
        ))}

      {/* Highlights */}
      {links
        .filter(link =>
          typeof link.highlight !== 'undefined'
            ? link.highlight === true
            : false,
        )
        .map(link => (
          <li key={link.label} style={{ marginLeft: '2rem' }}>
            <Link href={link.url}>
              <Button color="primary" variant="solid">
                {link.label}
              </Button>
            </Link>
          </li>
        ))}

      {themeSwitcher && (
        <li style={{ marginLeft: '1rem' }}>
          <ThemeToggler />
        </li>
      )}
    </ul>
  );
}

export default NavigationList;
